import { tipoInputEnum, tipoInputPadraoEnum } from "../components/CampoForm/enum/TipoInput.enum";
import { gerarGUID, gerarUUID } from "../util/uuid.utils";

/**
 * Modelo de objeto para Formulário de Tarefas do Cliente;
 * Versão simplificada sem validações de empresa e sócio do eLegalize
 * @class FormularioTarefa
 * @namespace FormularioTarefa
 */
export default class FormularioTarefa {
  constructor(id = null, nome = '', nomeHtml = '', camposPersonalizados = []) {
    this.id = id;
    this.nome = nome;
    this.nomeHtml = nomeHtml;
    this.camposPersonalizados = camposPersonalizados;
  }

  /**
   * Atualiza modelo com dados válidos de um objeto com dados de formulário
   * @param {Object} formData Objeto com dados do formulário
   */
  updateDados(formData) {
    for (let propriedade in formData) {
      if (!Object.keys(formData).includes(propriedade)) {
        console.warn(`WARN: Propriedade "${propriedade}" não é válida para modelo`);
        continue;
      }
      this[propriedade] = formData[propriedade];
    }
  }

  asRequestBody() {
    let camposClone = JSON.stringify(
      this.camposPersonalizados.map((item, index) => {
        item.ordem = index + 1;
        return item;
      })
    );
    camposClone = JSON.parse(camposClone);
    const body = {
      nome: this.nome,
      nomeHtml: this.nomeHtml,
      camposPersonalizados: this.converterCamposToRequest(camposClone)
    }
    if (this.id) {
      body.id = this.id;
    }
    return body;
  }

  converterCamposToRequest(campos) {
    const camposTratados = [];
    for (const campo of campos) {
      // Remove campos desnecessários
      delete campo.respostasSocios;
      
      // Mantém respostas
      const respostaTexto = campo.respostaTexto;
      const respostaTextoHtml = campo.respostaTextoHtml;
      const respostaOpcoes = campo.respostaOpcoes;
      
      delete campo.respostaOpcoes;
      delete campo.respostaTexto;
      delete campo.respostaTextoHtml;
      
      if (Array.isArray(campo.opcoes) && campo.opcoes.length > 0) {
        campo.opcoes = this.converterOpcoesToRequest(campo.opcoes);
      }
      
      if (!campo.blocoPadrao) {
        campo.tipoInput = tipoInputEnum.getByKey(campo.tipoInput).getId();
      } else {
        delete campo.tipoInput;
      }
      
      // Adiciona respostas de volta
      if (respostaTexto !== undefined && respostaTexto !== null) {
        campo.respostaTexto = respostaTexto;
      }
      if (respostaTextoHtml !== undefined && respostaTextoHtml !== null) {
        campo.respostaTextoHtml = respostaTextoHtml;
      }
      if (Array.isArray(respostaOpcoes) && respostaOpcoes.length > 0) {
        campo.respostaOpcoes = respostaOpcoes;
      }
      
      camposTratados.push(campo);
    }
    return camposTratados;
  }

  converterOpcoesToRequest(opcoes) {
    const opcoesConvertidas = [];
    for (const opcao of opcoes) {
      const opcaoConvertida = {
        ordem: opcao.ordem,
        descricao: opcao.label,
        descricaoHtml: opcao.labelHtml
      }
      opcoesConvertidas.push(opcaoConvertida)
    }
    opcoesConvertidas.sort((a, b) => a.ordem - b.ordem);
    return opcoesConvertidas
  }

  cleanBody(body) {
    for (const prop in body) {
      if (body[prop] === '' || body[prop] === null || (Array.isArray(body[prop]) && body[prop].length == 0)) {
        delete body[prop];
      }
    }
  }

  asModel(response) {
    this.id = response.id;
    this.nome = response.nome;
    this.nomeHtml = response.nomeHtml;
    this.camposPersonalizados = this.converterCamposToModel(response.camposPersonalizados || []);
  }

  converterCamposToModel(campos) {
    const camposConvertidos = [];
    campos.sort((a, b) => a.ordem - b.ordem);
    for (const campo of campos) {
      if (Array.isArray(campo.opcoes) && campo.opcoes.length > 0) {
        campo.opcoes = this.converterOpcoesToModel(campo.opcoes);
      }
      if (!!campo.blocoPadrao) {
        campo.tipoInput = tipoInputPadraoEnum.getById(campo.blocoPadrao).getKey();
      } else {
        campo.tipoInput = tipoInputEnum.getById(campo.tipoInput).getKey();
      }

      campo.uuid = gerarUUID();
      camposConvertidos.push(campo);
    }
    return camposConvertidos;
  }

  converterOpcoesToModel(opcoes) {
    const opcoesConvertidas = [];
    for (const opcao of opcoes) {
      const opcaoConvertida = {
        ordem: opcao.ordem,
        label: opcao.descricao,
        labelHtml: opcao.descricaoHtml,
        uuidEditor: gerarGUID()
      }
      opcoesConvertidas.push(opcaoConvertida)
    }
    opcoesConvertidas.sort((a, b) => a.ordem - b.ordem);
    return opcoesConvertidas
  }
}
